import React, {useEffect, useState} from "react";
import Timeline from "./charts/timeline";
import API from "../components/api/api";


const Dashboard = () => {
    const api = API("live")
    const redshift = API("redshift")
    const [logins, setLogins] = useState([])
    const [trxs, setTrxs] = useState([])
    const [trxsByBrand, setTrxsByBrand] = useState([])
    const [events, setEvents] = useState([])
    const processResponse = (resp) => {
        const d = resp.data.map(row => {
            const r = {}
            resp.cols.forEach( (name, i) => {
                if(name === "time"){
                    r[name] = new Date(row[i])
                } else {
                    r[name] = row[i]
                }
            })
            return r
        })
        return d
    }
    const loadLogins = async () => {
        const resp = await api.runNamedQuery("login_events")
        const d = processResponse(resp)
        setLogins(d)
    }
    const loadTrxs = async () => {
        const resp = await api.runNamedQuery("trxs_events")
        const d = processResponse(resp)
        setTrxs(d)
    }
    const loadTrxByBrand = async () => {
        const resp = await redshift.runNamedQuery("trxs_by_brand")
        const d = processResponse(resp)
        setTrxsByBrand(d)
    }
    const loadEvents = async () => {
        const resp = await api.runNamedQuery("all_events")
        const d = processResponse(resp)
        setEvents(d)
    }
    const loadAll = () => {
        loadLogins()
        loadTrxs()
        loadEvents()
        loadTrxByBrand()
    }
    useEffect(() => {
        loadAll()
        const refreshTimer = setInterval(loadAll, 1000*10)
        return () => {clearInterval(refreshTimer)}
    },[])


    return <div>{
        (logins) ?
            <div>
                <h3>login events</h3>
                <Timeline data={logins} xAxisProp="time" yAxisProp="account_id" ></Timeline>
            </div>
            :
            <div>no logins loaded</div>}
        {
        (trxs) ?
            <div>
                <h3>transaction events</h3>
                <Timeline data={trxs} xAxisProp="time" yAxisProp="account_id" ></Timeline>
            </div>
            :
            <div>no trxs loaded</div>}
        {
        (events) ?
            <div>
                <h3>all account-related events</h3>
                <Timeline data={events} xAxisProp="time" yAxisProp='action' ></Timeline>
            </div>
            :
            <div>no events loaded</div>}
        {
        (trxsByBrand) ?
            <div>
                <h3>transactions by brand</h3>
                <Timeline data={trxsByBrand} xAxisProp="time" yAxisProp='desc' ></Timeline>
            </div>
            :
            <div>no trxs by brand loaded</div>}
    </div>
}

export default Dashboard
